import SurveyController from './SurveyController'

export default SurveyController



// WEBPACK FOOTER //
// ./src/modules/Controllers/Survey/SurveyController/index.js